import m from "../../geodata/es2015/moroccoHigh";
window.am4geodata_moroccoHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/moroccoHigh.js
// module id = null
// module chunks = 